import React from 'react';
import './App.css';
import quizQuestions from './api/QuizQuestions';
import Quiz from './components/Quiz'
import Intro from './components/Intro'
import Result from './components/Result';
import Loading from './components/Loading'
import Fake from './components/Fake';
import InviteAccepted from './components/InviteAccepted';
import ViewReport from './components/ViewReport';
import PrePayment from './components/PrePayment';
import MyReports from './components/MyReports';
import CompareProfile from './components/CompareProfile';
import CompareReport from './components/CompareReport';
import {createBrowserHistory} from 'history';
import {Auth0ContextInterface, useAuth0, withAuth0} from "@auth0/auth0-react";
import {UserData} from './components/types';
import {BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom'
import Home from "./Home";
import MyOceanityNav from "./components/MyOceanityNav";
import ContactForm from "./components/content/ContactForm";
import WhatIsMyOceanity from "./components/content/WhatIsMyOceanity";
import HowDoesItWork from "./components/content/HowDoesItWork";
import WhoWeAre from "./components/content/WhoWeAre";
import FAQ from "./components/content/FAQ";
import OceanMethodology from "./components/content/OceanMethodology";
import EICourseOverview from "./components/content/EICourseOverview";
import OrganizeAnEvent from "./components/content/OrganizeAnEvent";
import Donations from "./components/content/Donations";
import WhatWeDo from './components/what-we-do';
import MyOceanityAndEI from './components/myoceanity-and-ei';
import Oceanology from './components/oceanology';
import OceanPersonalityTraits from './components/ocean-personality-traits';
import WhatIsEI from './components/what-is-ei';
import WhyEIMatters from './components/why-ei-matters';
import GrowYourEI from './components/grow-your-ei';
import EICourse from './components/ei-course';
import EIBenefitsHome from './components/ei-benefits-home';
import EIBenefitsWork from './components/ei-benefits-work';
import StrategiesForEI from './components/strategies-for-ei';
import CoreEmotions from './components/core-emotions';
import EmotionalLiteracy from './components/emotional-literacy';
import ReadingEmotions from './components/reading-emotions';
import IdentityIntroduction from './components/identity-introduction';
import Ikigai from './components/ikigai';
import IdentityMission from './components/identity-mission';
import IdentityValues from './components/identity-values';
import IdentityBeliefs from './components/identity-beliefs';
import JournalingSelfAwareness from './components/journaling-self-awareness';
import JournalingSelfDevelopment from './components/journaling-self-development';
import JournalingIntrospection from './components/journaling-introspection';
import Updates from './components/updates';
import Resources from './components/resources';
import SupportAndDonations from './components/support-and-donations';
import Events from './components/events';
import PrivacyPolicy from "./components/PrivacyPolicy";

export enum VIEW_STATE {
    INTRO,
    QUIZ,
    LOADING,
    UNPAID,
    REPORT
}

export interface AppState {
    questions: Array<any>
    counter: number;
    currentQuestionId: string;
    currentQuestion: string;
    answerOptions: Array<string>;
    currentAnswer: string;
    answerState: Map<string, string>;
    result: {
        AGREEABLENESS: number
        CONSCIENTIOUSNESS: number
        EXTROVERSION: number
        NERVOSITY: number
        OPENNESS: number
    };
    viewState: VIEW_STATE;
    userData: UserData | null;
    jwt: string | null;
    loading: boolean;
    reportLink: string;
}

export interface AppProps {
    auth0: Auth0ContextInterface
}

function PrivateRoute({children, ...rest}) {
    const {isAuthenticated, loginWithRedirect, isLoading} = useAuth0();
    if (isLoading) {
        return null;
    }
    return (
        <Route
            {...rest}
            render={({location}) =>
                 isAuthenticated ? (
                    children
                ) : (loginWithRedirect({redirectUri:window.location.origin,appState: { targetUrl: window.location.href }}))
            }
        />

    );
}



export class App extends React.Component<AppProps, AppState> {


    constructor(props: any) {
        super(props);
        this.state = {
            questions: [],
            counter: 0,//quizQuestions.length - 1,
            currentQuestionId: '',
            currentQuestion: '',
            answerOptions: ['1', '2', '3', '4', '5'],
            currentAnswer: '0',
            answerState: new Map<string, string>(),
            result: {
                AGREEABLENESS: 0,
                CONSCIENTIOUSNESS: 0,
                EXTROVERSION: 0,
                NERVOSITY: 0,
                OPENNESS: 0
            },
            viewState: VIEW_STATE.LOADING,
            userData: null,
            jwt: null,
            loading: true,
            reportLink: ''
        };
        this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
        this.handleBackSelected = this.handleBackSelected.bind(this);
        this.handleStartQuiz = this.handleStartQuiz.bind(this);
    }

    async componentDidMount() {
        this.setState({loading: true});
        const shuffledAnswerOptions = this.shuffleArray(quizQuestions);
        this.setState({
            questions: shuffledAnswerOptions,
            currentQuestionId: shuffledAnswerOptions[0].id,
            currentQuestion: shuffledAnswerOptions[0].question
        });
        if (window.location.href.includes("/user")) {
            await this.refreshUserData().then(value => {
                this.setState({loading: false});
            });
        }else{
            this.setState({loading: false});
        }


    }


    private async refreshUserData() {
        this.setState({loading:true});
        if (!this.props.auth0.isLoading) {
            console.log("silent auth");
             await this.props.auth0.getAccessTokenSilently({
                audience: 'quiz-backend'
            }).then(token => {
                this.setState({'jwt': token})
                fetch('https://9ap0wh9yya.execute-api.eu-central-1.amazonaws.com/user-data', {
                    headers: {
                        'Authorization': `Bearer ${this.state.jwt}`,
                    }
                }).then(response => {
                    if (response.status === 200) {
                        return response.json();
                    } else {
                        if (response.status === 204) {
                            return ({quiz: []})
                        }
                    }
                }).then(data => {
                    //console.log(this.props.auth0);
                    this.setState({userData: data, loading: false});
                });
            });
        }else{
            //console.log("can't refresh user data while auth is loading");
            setTimeout(()=> this.refreshUserData().then(value => this.setState({loading:false})),50)
        }
    }

    shuffleArray(array: any) {
        var currentIndex = array.length, temporaryValue, randomIndex;
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    };


    handleBackSelected(event: any) {
        if (this.state.counter === 0) {
            this.setState({viewState: VIEW_STATE.INTRO});
        } else {
            const counter = this.state.counter - 1;
            const questionId = this.state.questions[counter].id;
            this.setState({
                counter: counter,
                currentQuestionId: questionId,
                currentQuestion: quizQuestions[counter].question,
                currentAnswer: this.state.answerState.get(questionId) as string
            });
        }
        ;
    }

    handleStartQuiz() {
        this.setState({viewState: VIEW_STATE.QUIZ});
    }

    handleAnswerSelected(event: any) {
        this.setUserAnswer(event.currentTarget.value);
        if (this.state.counter < quizQuestions.length - 1) {
            setTimeout(() => this.setNextQuestion(), 500);
        } else {
            setTimeout(() => this.getResults(), 300);
        }
    }

    setUserAnswer(answer: string) {
        let answerState = this.state.answerState
        answerState.set(this.state.currentQuestionId, answer)
        this.setState({currentAnswer: answer, answerState: answerState})
    }

    setNextQuestion() {
        if (this.state.counter < quizQuestions.length - 1) {
            const counter = this.state.counter + 1;
            const currentQuestionId = this.state.questions[counter].id;
            this.setState({
                counter: counter,
                currentQuestionId: currentQuestionId,
                currentQuestion: this.state.questions[counter].question,
                currentAnswer: '0'
            });
        }
    }

    getResults() {
        this.setState({counter: this.state.counter + 1})
        const convMap: any = {};
        this.state.answerState.forEach((val: string, key: string) => {
            convMap[key] = val;
        });

       fetch('https://9ap0wh9yya.execute-api.eu-central-1.amazonaws.com/quiz', {
            method: 'POST',
            body: JSON.stringify({answerState: convMap}),
            headers: {
                'Authorization': `Bearer ${this.state.jwt}`,
            }
        }).then(response => {
            if (response.status === 200 || response.status === 201) {
                return response.json();
            }
        }).then(data => {
            this.refreshUserData().then(() => {
                this.setState({result: data, reportLink: `/user/premium/view/${data['quizId']}`});
            });
        }).finally(() => {
            this.setState({loading: false});
        });
    }


    renderQuiz() {
        return (
            this.state.userData?.paid ?
                <Quiz
                    answer={this.state.currentAnswer}
                    answerOptions={this.state.answerOptions}
                    questionId={this.state.currentQuestionId}
                    question={this.state.currentQuestion}
                    questionTotal={this.state.questions.length}
                    onAnswerSelected={this.handleAnswerSelected}
                    onBack={this.handleBackSelected}
                    counter={this.state.counter}
                    reportLink={this.state.reportLink}
                />
                : !this.props.auth0.isLoading && this.state.userData ?
                <PrePayment email={this.props.auth0.user.email} userId={this.props.auth0.user.sub}/> : <Loading/>
        );
    }

    renderResult() {
        return (
            <Result quizResult={this.state.result} username={this.props.auth0.user.name}/>
        );
    }

    renderIntro() {
        return (
            <Intro action={this.handleStartQuiz}/>
        );
    }

    renderLoading() {
        return (
            <Loading/>
        );
    }

    gated() {
        return ((this.state.loading) ? <Loading/> :
                <div className="App">
                    <header>
                        <MyOceanityNav/>
                    </header>
                    <Router>
                        <Switch>
                            <Route path="/quiz/fake/o/:o/c/:c/e/:e/a/:a/n/:n">
                                <Fake/>
                            </Route>
                            <PrivateRoute path="/user/premium/view/:reportId">
                                {this.state.userData && !this.props.auth0.isLoading ?
                                    <ViewReport userData={this.state.userData}
                                                username={this.props.auth0.user.nickname}/> : <Loading/>}
                            </PrivateRoute>
                            <PrivateRoute path="/user/premium/my-assessments">
                                {this.state.userData && !this.props.auth0.isLoading ?
                                    <MyReports userData={this.state.userData}/> : <Loading/>}

                            </PrivateRoute>
                            <PrivateRoute path="/user/premium/quiz">
                                {this.state.userData ? this.renderQuiz() : <Loading/>}
                            </PrivateRoute>
                            <PrivateRoute path="/user/premium/send-invite">
                                {this.state.userData && !this.props.auth0.isLoading ?
                                    <CompareProfile quiz={this.state.userData.quiz}
                                                    username={this.props.auth0.user.nickname}
                                                    jwt={this.state.jwt} userEmail={this.props.auth0.user.name}
                                                    profileSharedWith={this.state.userData.profileSharedWith}/> :
                                    <Loading/>}
                            </PrivateRoute>
                            <PrivateRoute path="/user/premium/compare/:otherUid">
                                {this.state.userData && !this.props.auth0.isLoading ?
                                    <CompareReport quiz={this.state.userData.quiz}
                                                   username={this.props.auth0.user.nickname}
                                                   jwt={this.state.jwt}/> : <Loading/>}
                            </PrivateRoute>
                            <PrivateRoute path="/user/premium/accept-invite/:inviteCode">
                                {this.state.userData && !this.props.auth0.isLoading ?
                                    <InviteAccepted quiz={this.state.userData.quiz}
                                                    username={this.props.auth0.user.nickname}
                                                    jwt={this.state.jwt}/> : <Loading/>}
                            </PrivateRoute>
                            <Route path="/contact/">
                                <ContactForm/>
                            </Route>
                            <Route path="/what-is-myoceanity">
                                <WhatIsMyOceanity/>
                            </Route>
                            <Route path="/how-does-it-work">
                                <HowDoesItWork/>
                            </Route>
                            <Route path="/who-we-are">
                                <WhoWeAre/>
                            </Route>
                            <Route path="/faq">
                                <FAQ/>
                            </Route>
                            <Route path="/ocean-methodology/">
                                <OceanMethodology/>
                            </Route>
                            <Route path="/ei-course-overview/">
                                <EICourseOverview/>
                            </Route>
                            <Route path="/organize-an-event/">
                                <OrganizeAnEvent/>
                            </Route>
                            <Route path="/donations/">
                                <Donations/>
                            </Route>
                            <Route path="/what-we-do">
                                <WhatWeDo/>
                            </Route>
                            <Route path="/myoceanity-and-ei">
                                <MyOceanityAndEI/>
                            </Route>
                            <Route path="/oceanology">
                                <Oceanology/>
                            </Route>
                            <Route path="/ocean-personality-traits">
                                <OceanPersonalityTraits/>
                            </Route>
                            <Route path="/what-is-ei">
                                <WhatIsEI/>
                            </Route>
                            <Route path="/why-ei-matters">
                                <WhyEIMatters/>
                            </Route>
                            <Route path="/grow-your-ei">
                                <GrowYourEI/>
                            </Route>
                            <Route path="/ei-course">
                                <EICourse/>
                            </Route>
                            <Route path="/ei-benefits-home">
                                <EIBenefitsHome/>
                            </Route>
                            <Route path="/ei-benefits-work">
                                <EIBenefitsWork/>
                            </Route>
                            <Route path="/strategies-for-ei">
                                <StrategiesForEI/>
                            </Route>
                            <Route path="/core-emotions">
                                <CoreEmotions/>
                            </Route>
                            <Route path="/emotional-literacy">
                                <EmotionalLiteracy/>
                            </Route>
                            <Route path="/reading-emotions">
                                <ReadingEmotions/>
                            </Route>
                            <Route path="/identity-introduction">
                                <IdentityIntroduction/>
                            </Route>
                            <Route path="/ikigai">
                                <Ikigai/>
                            </Route>
                            <Route path="/identity-mission">
                                <IdentityMission/>
                            </Route>
                            <Route path="/identity-values">
                                <IdentityValues/>
                            </Route>
                            <Route path="/identity-beliefs">
                                <IdentityBeliefs/>
                            </Route>
                            <Route path="/journaling-self-awareness">
                                <JournalingSelfAwareness/>
                            </Route>
                            <Route path="/journaling-self-development">
                                <JournalingSelfDevelopment/>
                            </Route>
                            <Route path="/journaling-introspection">
                                <JournalingIntrospection/>
                            </Route>
                            <Route path="/updates">
                                <Updates/>
                            </Route>
                            <Route path="/resources">
                                <Resources/>
                            </Route>
                            <Route path="/support-and-donations">
                                <SupportAndDonations/>
                            </Route>
                            <Route path="/events">
                                <Events/>
                            </Route>
                            <Route path="/privacy-policy">
                                <PrivacyPolicy/>
                            </Route>
                            <Route path="/callback">
                                <Redirect to={"/"}/>
                            </Route>
                            <Route path="/">
                                <Home/>
                            </Route>
                        </Switch>
                    </Router>
                </div>
        )
    }

    render() {
        const history = createBrowserHistory();

        const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
        if (path) {
            history.replace(path);
        }
        return this.gated()

    }

}

export default withAuth0(App);